<template>
	<div class="text-left block-editor-context display-flex" v-if="element">
		<ButtonEditorDrawer v-bind="buttonEditorDrawerProps" v-on="buttonEditorDrawerListeners" :hasEditPermissions="hasEditPermissions">
			ButtonEditorDrawer
		</ButtonEditorDrawer>
	</div>
	<div cols="12" class="text-left" v-else>
		<BlockEditorToolBlock v-if="isTool" />
		<ScheduledCloudWorkflowBlock v-else-if="isOfTypeScheduledCloud" />
		<CloudWorkflowBlock v-else-if="isCloudFlow" />
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BlockEditorToolBlock from '@/components/BlockEditorToolWorkflow/BlockEditorToolBlock';
import CloudWorkflowBlock from '@/components/BlockEditorAutomationWorkflow/CloudWorkflowBlock';
import ScheduledCloudWorkflowBlock from '@/components/BlockEditorAutomationWorkflow/ScheduledCloudWorkflowBlock';

import ButtonEditorDrawer from './ButtonEditorDrawer';
import debounce from 'lodash/debounce';
import { updateInjectedElementStyle } from '@/store/modules/uiElements/actions';
import { updateNativeElement } from '@/store/modules/nativeElements/actions';
import { getAction } from '@/store/modules/actions/getters';
import {
	isOfTypeTool,
	isOfTypeFeature,
	isOfTypeCloud,
	isOfTypeScheduledCloud,
	element,
	editWorkflow,
	isNativeElement,
	editedWorkflowVersion,
} from '@/store/modules/selectedWorkflow/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';

export default {
	name: 'BlockEditorContext',
	props: {
		hasEditPermissions: { type: Boolean },
	},
	data: () => ({}),
	components: {
		CloudWorkflowBlock,
		ScheduledCloudWorkflowBlock,
		BlockEditorToolBlock,
		ButtonEditorDrawer,
	},
	computed: {
		...mapGetters([
			element.fullPath,
			editWorkflow.fullPath,
			isNativeElement.fullPath,
			editedWorkflowVersion.fullPath,
			getAction.fullPath,
			isOfTypeTool.fullPath,
			isOfTypeFeature.fullPath,
			isOfTypeCloud.fullPath,
		]),
		...mapGettersShorthand({ isOfTypeScheduledCloud }),
		element() {
			return this[element.fullPath];
		},
		isNativeElement() {
			return this[isNativeElement.fullPath];
		},
		isTool() {
			return this[isOfTypeTool.fullPath];
		},
		isCloudFlow() {
			return this[isOfTypeCloud.fullPath];
		},
		buttonEditorBindData() {
			return {
				presetTitle: this[editedWorkflowVersion.fullPath]?.workflow_title,
				injectionStyle: this.element?.metadata?.injectionStyle || {},
				isNewButton: false,
			};
		},
		buttonEditorListeners() {
			const listeners = {
				updatePlacement: () => {
					// console.log('updatePlacement', payload);
					// chrome.runtime.sendMessage({ action: 'updateInjectionStyle', value: { style: payload, id: editedElementId } }, () => {});
				},
				openFlowBuilder: (editElement) => {
					console.log('openFlowBuilder', editElement);
				},
				close: () => {
					console.log('close');
				},
				clearEditMode: () => {
					console.log('clearEditMode');
				},
				notificationService: (title, content) => {
					console.log('notificationService', title, content);
				},
				updateWorkflowTitle: (title) => {
					console.log('updateWorkflowTitle', title);
				},
				deleteWorkflow: () => {
					console.log('deleteWorkflow');
				},
				openButtonEditorDrawer: () => undefined,
			};
			return listeners;
		},
		buttonEditorDrawerProps() {
			return {
				injectionStyle: (this.isNativeElement ? this.element?.data : this.element?.metadata?.injectionStyle) || {},
				isDrawerOpen: false,
				elementId: this.element.id,
				workflowId: this[editWorkflow.fullPath].id,
				isNative: this.isNativeElement,
			};
		},
		buttonEditorDrawerListeners() {
			return {
				updateElement: (...args) => this.updateElement(...args),
			};
		},
	},
	methods: {
		...mapActions([updateInjectedElementStyle.fullPath, updateNativeElement.fullPath]),
		updateElement: debounce(function (data, id) {
			const updateMethod = this.isNativeElement ? this[updateNativeElement.fullPath] : this[updateInjectedElementStyle.fullPath];
			updateMethod({ id, data });
		}, 200),
	},
	watch: {},
};
</script>

<style scoped lang="scss">
.block-editor-context {
	height: 100%;
}
h2.boldic {
	color: #292829;
	font-size: 16px;
	font-weight: 700 !important;
}
h2 {
	font-weight: 600 !important;
}
.context_name {
	background: rgba(240, 240, 243, 0.59);
	width: 100%;
	height: 45px;
	border-radius: 3px !important;
	line-height: 45px;
	vertical-align: middle;
	padding: 0px 13px;
}
.ac_card {
	position: relative;
	display: inline-block !important;
	width: 21px !important;
	height: 21px !important;
	border-radius: 5px !important;
	vertical-align: middle !important;
	background: #fcfdff !important;
	box-sizing: border-box;
	border: 1px solid #d1d6e2;
}
.centerdXY {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}
.bold {
	font-weight: 700 !important;
}
.set_btn {
	padding: 10px !important;
	top: 2px;
	font-size: 14px !important;
	font-weight: 400;
	color: #5e7288;
}
</style>
